/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { PdfRequestBuilderRequestsMetadata, type PdfRequestBuilder } from './pdf/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/subscriptions/invoices/{invoiceId}
 */
export interface WithInvoiceItemRequestBuilder extends BaseRequestBuilder<WithInvoiceItemRequestBuilder> {
    /**
     * The pdf property
     */
    get pdf(): PdfRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithInvoiceItemRequestBuilderUriTemplate = "{+baseurl}/api/organizations/subscriptions/invoices/{invoiceId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithInvoiceItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithInvoiceItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    pdf: {
        requestsMetadata: PdfRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
